import { useState } from 'react';
import { groupAlerts } from '../lib/alerts';

const LV = {
  bad:  { dot: '#C0392B', bg: '#FBECEB' },
  warn: { dot: '#D69E2E', bg: '#FAF3E2' },
  info: { dot: '#185fa5', bg: '#E9F1FA' },
};

export function GoBtn({ onClick, small }) {
  return (
    <button onClick={(e) => { e.stopPropagation(); onClick(); }}
      style={{ border: '1px solid #BBD6EE', background: '#EBF4FF', color: '#1F5F9C', borderRadius: 6, padding: small ? '4px 10px' : '5px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap', flex: 'none' }}>
      Перейти
    </button>
  );
}

// Лента «Требует внимания»: все алёрты по категориям, у каждого — «Перейти».
// showSv — показывать имя СВ/ТМ в строке (detail уже содержит СВ; для РМ добавляем ТМ).
export default function AlertRibbon({ alerts, onGo, showTm = false, perCat = 5 }) {
  const [open, setOpen] = useState(true);
  const [active, setActive] = useState(null);   // открытая группа (по одной — лента не раздувается)
  const [all, setAll] = useState(false);
  if (!alerts.length) return null;
  const groups = groupAlerts(alerts);
  const cur = groups.find(g => g.label === active) || null;
  const shown = cur ? (all ? cur.items : cur.items.slice(0, perCat)) : [];
  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 10, boxShadow: 'var(--shadow)', marginBottom: 12, overflow: 'hidden' }}>
      <div onClick={() => setOpen(o => !o)} style={{ padding: '10px 16px', background: '#FFF7E0', borderBottom: open ? '1px solid #F0D58A' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: '#6B4A00' }}>🔔 Требует внимания · {alerts.length}</span>
        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{open ? 'Свернуть' : 'Развернуть'}</span>
      </div>
      {open && (
        <>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', padding: '10px 12px' }}>
            {groups.map(gr => {
              const bad = gr.items.some(x => x.level === 'bad');
              const on = active === gr.label;
              return (
                <button key={gr.label} onClick={() => { setActive(on ? null : gr.label); setAll(false); }}
                  style={{ cursor: 'pointer', fontSize: 12, fontWeight: 700, padding: '6px 12px', borderRadius: 20,
                    border: `1.5px solid ${on ? '#1F5F9C' : bad ? '#E8A5A0' : '#F0C56A'}`,
                    background: on ? '#1F5F9C' : bad ? '#FBECEB' : '#FFF7E0',
                    color: on ? '#fff' : bad ? '#9C0006' : '#8A6100' }}>
                  {gr.label} · {gr.items.length}
                </button>
              );
            })}
          </div>
          {cur && (
            <div>
              {shown.map(a => (
                <div key={a.id} style={{ padding: '8px 16px', display: 'flex', gap: 10, alignItems: 'center', borderTop: '1px solid #EDF2F7' }}>
                  <span style={{ width: 10, height: 10, borderRadius: '50%', background: (LV[a.level] || LV.warn).dot, flex: 'none' }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700 }}>{a.title}</div>
                    <div style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{showTm && a.tmName ? `${a.tmName} · ` : ''}{a.detail}</div>
                  </div>
                  <GoBtn onClick={() => onGo(a)} />
                </div>
              ))}
              {cur.items.length > perCat && (
                <div onClick={() => setAll(v => !v)} style={{ padding: '8px 16px', fontSize: 12, color: 'var(--accent)', fontWeight: 600, cursor: 'pointer', borderTop: '1px solid #EDF2F7' }}>
                  {all ? 'Свернуть' : `Показать ещё ${cur.items.length - perCat}`}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
